export default "__VITE_ASSET__BJnM3q8h__"